<template>
    <div class="video-view">
        <div
            v-for="(video, indx) in videos"
            :key="indx"
            @mouseover="$emit('update:hover-index', indx)"
            @mouseleave="$emit('update:hover-index', null)"
            class="videos-wrapper"
        >
            <video
                ref="videoRefs"
                :src="video.src"
                @loadedmetadata="$emit('load-video', video, $refs['videoRefs'])"
                class="video"
            ></video>
            <button @click="playVideo(video, indx)" class="play-btn">
                <span class="title">
                    {{ `${video.name} - ${video.duration}` }}
                </span>
                <img
                    v-if="!video.playing"
                    src="/images/icons/video-play.svg"
                    alt="play-btn"
                    class="play-icon"
                />
            </button>
            <button
                v-if="hoverIndex === indx && editable"
                @click="$emit('delete-video', indx)"
                class="delete-btn"
            >
                <img src="/images/icons/trash-can.svg" alt="delete" />
            </button>
        </div>
    </div>
</template>
<script>
    import { ref } from 'vue'
    export default {
        name: 'VideoView',
        props: {
            videos: {
                type: Array,
                required: false,
                default: () => []
            },
            hoverIndex: {
                type: Number,
                required: false
            },
            editable: {
                type: Boolean,
                required: false,
                default: true
            }
        },
        emits: ['load-video', 'delete-video', 'update:hover-index'],
        setup() {
            const videoRefs = ref(null)

            return { videoRefs }
        },
        computed: {
            videoPlaying() {
                return (indx) => {
                    const video = this.videoRefs ? this.videoRefs[indx] : null
                    return !!(
                        video &&
                        video.currentTime > 0 &&
                        !video.paused &&
                        !video.ended &&
                        video.readyState > 2
                    )
                }
            }
        },
        methods: {
            playVideo(video, indx) {
                const videoRef = this.videoRefs[indx]

                if (!video.playing) {
                    videoRef.play()
                    video.playing = true
                } else {
                    videoRef.pause()
                    video.playing = false
                }
            }
        },
        mounted() {
            this.hoverIndex = null
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../../../sass/_variables.scss';
    .video-view {
        p {
            margin-bottom: 0px;
        }
        button {
            border: none;
        }

        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        gap: 16px;

        .videos-wrapper {
            position: relative;
            max-width: 400px;
            width: 100%;

            .video {
                width: 100%;
                height: 225px;
                border-radius: 8px;
            }
            .play-btn {
                background: none;
                position: absolute;
                width: 100%;
                max-width: 400;
                height: 225px;
                top: 0;
                left: 0;
                box-shadow: 0px -120px 50px -50px rgba(0, 0, 0, 0.3) inset;
                border-radius: 8px;

                .title {
                    position: absolute;
                    left: 1%;
                    bottom: 20px;
                    color: #dedede;
                    @include base-font-16;
                    font-weight: 550;
                    line-height: 125%;
                }

                .play-icon {
                    position: absolute;
                    left: 40%;
                    top: 26%;
                }
            }
            .delete-btn {
                background: none;
                position: absolute;
                width: fit-content;
                height: fit-content;
                top: 0;
                right: 10px;
                padding: 0px;

                img {
                    width: 20px;
                    height: 20px;
                    object-fit: cover;
                }
            }
        }
    }
</style>
